import { useEffect, useMemo } from 'react';

import { useLogger } from '@/shared/hooks/useLogger';

import { usePrerollDuration } from '../../feature-player/hooks/skin/use-preroll-duration';
import { useInitTracker } from '../../feature-player/hooks/tracker/use-init-tracker';
import { getStreamsTrackingData } from '../../feature-player/utils/get-streams-tracking-data';
import { getNotNullableItems } from '../../../lib/get-not-nullable-items';

import { useEpisodeCurrentStream } from './use-episode-current-stream';

interface YandexMetrika {
    main: number;
}

export const useInitEpisodeTracker = (contentId: string, yandexMetrika: YandexMetrika) => {
    const stream = useEpisodeCurrentStream(contentId);

    const prerollTargetContentId = useMemo(
        () =>
            getNotNullableItems(stream?.streamMeta?.prerolls)[0]?.promotedEntityId?.toString() ||
            '',
        [stream?.streamMeta?.prerolls]
    );
    const prerollDurationSeconds = usePrerollDuration();

    const logger = useLogger();

    useEffect(() => {
        if (prerollDurationSeconds && !prerollTargetContentId) {
            logger.error(
                { stream, prerollDurationSeconds, prerollTargetContentId, type: 'episode' },
                'Non-empty preroll duration with empty prerollTargetContentId'
            );
        }
    }, [logger, prerollDurationSeconds, prerollTargetContentId, stream]);

    useInitTracker({
        contentId,
        additionalParams: { prerollDurationSeconds, prerollTargetContentId },
        additionalData: {
            prerollTargetContentId: prerollTargetContentId?.toString() || '',
            metrikaKey: yandexMetrika.main.toString(),
        },
        streamTrackingData: getStreamsTrackingData(stream?.streamMeta?.trackings),
    });
};
